<!--
 * @Author       : Tom
 * @Date         : 2019-12-25 09:45:55
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 17:47:01
 * @FilePath     : /shop_front_end/src/views/goods_manage/optional.vue
 * @Description  : 商品管理-添加商品
 -->
<template>
  <div class="client_manage">
    <a-card title="添加商品" :bordered="false">

      <a-form class="optionalform">
		  
        <a-form-item label="选择源平台商品" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" style="margin-bottom: 4px;">

          <a-radio-group v-model="value">
            <a-radio-button value="1">查询商品</a-radio-button>
            <a-radio-button value="2">已选商品</a-radio-button>
          </a-radio-group>

          <!-- 查询商品 -->
          <div v-show="value == '1'">
            <a-form  layout="inline" class="optionalquery" :data="form" style="margin: 8px 0 12px;">
              <a-form-item>
                <a-cascader
                  v-if="optionstype.length"
                  style="width: 195px"
                  :fieldNames="{ label: 'pname', value: 'cid', children: 'children' }"
                  :options="optionstype"
                  @change="onChangeCall"
                  :displayRender="displayRender"
                  changeOnSelect
                  :loadData="loadData"
                  placeholder="请选择商品分类"
                  v-model="product_class"
                />
                <a-select v-else placeholder="请选择商品分类" style="width: 195px"></a-select>
              </a-form-item>
            
              <a-form-item>
                <a-select allowClear placeholder="请选择商品品牌" style="width: 195px" v-model="brand_id">
                  <a-select-option v-for="(item,i) in brandlist" :key="i" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
                </a-select>
              </a-form-item>
            
              <a-form-item>
                <a-input placeholder="请输入商品名称" style="width:300px;" v-model="proName"></a-input>
              </a-form-item>

              <a-form-item>
                <a-button type="" @click="onReset">重置</a-button>
              </a-form-item>
              
              <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
              </a-form-item>
            </a-form>


            <a-table id="tabss" :columns="columnsA" :dataSource="data" :scroll="{ x: 1200, y: 450 }"
                     :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                     :loading="loading"
                     :pagination="pagination" @change="onChangess"
            >
              <template slot="titles" slot-scope="text">
                <img :src="text.imgurl" style="widht:40px;height:40px;" />
                {{ text.product_title }}
              </template>

              <span slot="action" slot-scope="text">
                <a-button size="small" @click="onOpenDetails(text)">查看详情</a-button>
              </span>

              <template slot="footer">
                <div class="box-footer">
                  <span>已选 <span>{{ selectedRow.length }}</span> 款商品</span>

                  <span>共 <span>{{ total }}</span> 款商品</span>
                </div>
              </template>
            </a-table>

          </div>
          <div v-show="value == '2'">
            <a-table :columns="columnsB" :dataSource="selected_list">
              
              <template slot="titles" slot-scope="text">
                <img :src="text.imgurl" style="widht:40px;height:40px;" />
                {{ text.product_title }}
              </template>

              <span slot="action" slot-scope="text,p,index">
                <a-button size="small" @click="onDelp(index)">删除</a-button>
                <a-divider type="vertical" />
                <a-button size="small" @click="onOpenDetails(text)">查看详情</a-button>
              </span>

              <template slot="footer">
                <div class="box-footer">
                  <span>已选 <span>{{ selected_list.length }}</span> 款商品</span>

                  <span>共 <span>{{ total }}</span> 款商品</span>
                </div>
              </template>
            </a-table>
          </div>

        </a-form-item>

		<a-form-item label="运费模板" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" style="margin-top: 14px;margin-bottom: 0;">
			<a-select v-model="freight_id" placeholder="请选择运费模板" style="width: 195px">
			  <a-select-option v-for="item,index of freight_list" :key="item.id" :value="item.id">
				{{item.name}}
			  </a-select-option>
			</a-select>
		</a-form-item>
		
		<a-form-item label=" " :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" style="opacity: 0;margin: 0;height: 10px;">
			
		</a-form-item>
      </a-form>

     
    </a-card>
	
	<div class="foot">
	  <a-button type="primary" ghost class="btns" @click="onGoBack">取消</a-button>
	  <a-button type="primary" @click="onFromBtn">保存</a-button>
	</div>

    <!-- 查看详情 -->
    <a-modal title="查看详情" v-model="visible" width="1000px" :footer="null">
      <div class="box">
        <a-form >
          
          <a-form-item label="商品标题" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.product_title }}</span>
          </a-form-item>

          <a-form-item label="副标题" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.subtitle }}</span>
          </a-form-item>

          <a-form-item label="关键词" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.keyword }}</span>
          </a-form-item>

          <!-- <a-form-item label="重量" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.weight }}{{ CommodData.weight_unit }}</span>
          </a-form-item> -->


          <a-form-item label="商品类别" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.product_class_name }}</span>
          </a-form-item>

          <a-form-item label="商品品牌" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
            <span>{{ CommodData.brand_class_name }}</span>
          </a-form-item>

          <a-form-item label="商品展示图" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

            <span v-for="(item,i) in CommodData.imgurls" :key="i" class="productimg">
              <img :src="item.product_url" style="width:80px;height:80px;">
              <span v-if="item.is_center" class="productimg-title">主图</span>
            </span>

          </a-form-item>

          <a-form-item label="商品属性" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">

            <a-table :columns="columnsc" :dataSource="tableData">
              <template slot="img" slot-scope="text">
                <img :src="text" style="width: 80px;height:80px">
              </template>
            </a-table>

          </a-form-item>

          <a-form-item label="商品详情" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
            <div class="adcx" v-if="CommodData.content" v-html="CommodData.content"></div>
            <div v-else>暂无</div>

          </a-form-item>
          
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import $ from "jquery"

const columnsc = [
  {
    title:'成本价',
    dataIndex: 'costprice',
    key: 'costprice',
    scopedSlots: { customRender: 'costprice' },
  },
  {
    title:'原价',
    dataIndex: 'yprice',
    key: 'yprice',
    scopedSlots: { customRender: 'yprice' },
  },
  {
    title:'售价',
    dataIndex: 'price',
    key: 'price',
    scopedSlots: { customRender: 'price' },
  },
  {
    title:'库存',
    dataIndex: 'num',
    key: 'num',
    scopedSlots: { customRender: 'num' },
  },
  {
    title:'单位',
    dataIndex: 'unit',
    key: 'unit'
  },
  {
    title:'条形码',
    dataIndex: 'bar_code',
    key: 'bar_code',
    scopedSlots: { customRender: 'bar_code' },
  },
  {
    title:'上传图片',
    dataIndex: 'img',
    key: 'img',
    scopedSlots: { customRender: 'img' },
  }
]

const columnsA = [
  {
    title: '商品名称',
    key:'titles',
    scopedSlots: { customRender: 'titles' },
    width:300
  },
  {
    title: '分类',
    key:'product_class_name',
    dataIndex:'product_class_name',
    width:150
  },
  {
    title: '品牌',
    key:'brand_name',
    dataIndex:'brand_name',
    width:150
  },
  {
    title: '库存',
    key: 'num',
    dataIndex:'num',
    width:100
  },
  {
    title:'成本价',
    key:'yprice',
    dataIndex:'yprice',
    width:150
  },
  {
    title:'售价',
    key:'price',
    dataIndex:'price',
    width:150
  },
  {
    title:'操作',
    key:'action',
    scopedSlots: { customRender: 'action' }
  }
]

const columnsB = [
  {
    title: '商品名称',
    key:'titles',
    scopedSlots: { customRender: 'titles' }
  },
  {
    title: '分类',
    key:'product_class_name',
    dataIndex:'product_class_name',
    width:150
  },
  {
    title: '品牌',
    key:'brand_name',
    dataIndex:'brand_name',
    width:150
  },
  {
    title: '库存',
    key: 'num',
    dataIndex:'num'
  },
  {
    title:'成本价',
    key:'yprice',
    dataIndex:'yprice'
  },
  {
    title:'售价',
    key:'price',
    dataIndex:'price'
  },
  {
    title:'操作',
    key:'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  data(){
    return {
      data: [],
      columnsA,
      columnsB,
      value: '1',
      visible: false,
      selectedRowKeys: [],
      selectedRow: [],
      brandlist: [],
      options: [],
      optionstype: [],
      form: this.$form.createForm(this, { name: 'query_form' }),
      product_class:[],
      proName: '',
      brand_id: undefined,
      CommodData: {},
      columnsc,
      tableData: [],
      loading: true,
      total: 0,
      pagination: {},
      spppid:undefined,
      nums: 0,
      current:1,
      cache: {},
	  selected_list: [],
	  
	  freight_id: undefined,
	  freight_list: []
    }
  },
  watch:{
    value(val){
      console.log(val)
    }
  },
  mounted(){
    this.initPage()

    this.getCommodityClass()

    this.getCommodityClassType()
  },
  methods:{
	  changeFreight(val){
		  this.freight_id = val
	  },
    onChangeCall(value, selectedOptions){

      if(!value.length){
        this.brandlist = []
        this.brand_id  = undefined
      }

      console.log(value)

      this.brandlist = this.cache[value[value.length - 1]]
    },
    onChangess(pagination){
		this.selectedRow = []
		this.selectedRowKeys = []
        this.current = pagination.current
        this.getPageData(pagination)
    },
    /**
     * @name 获取分页数据
     */
    getPageData(pagination){

      let { product_class, proName, brand_id } = this

      let data = {}

      if(proName)  {data['proName']  = proName}
      if(brand_id) {data['brand_id'] = brand_id}
      
      for(let i in product_class){
        if(i == 0){
          data['product_class'] = product_class[i]
          continue
        }
        data['product_class' + i] = product_class[i]
      }

      data = {...data,page:pagination.current, ...pagination }


      this.loading = true
      this.$request.get('?module=pc_api&action=product&app=add_goods_page_load',{ params: data }).then(res => {
		  if(res.list && res.list.length>0){
			 let selectedRow = []
			 let selectedRowKeys = []
			  this.selected_list.filter(items=>{
			  		res.list.filter((item,index)=>{
						if(items.id == item.id){
							selectedRow.push(item)
							selectedRowKeys.push(index)
						}
					})	  
			  })
			  this.selectedRow = selectedRow
			  this.selectedRowKeys = selectedRowKeys
		  }
		  
		  
        this.data = res.list
        this.total = res.total
        this.loading = false
      })

    },
    /**
     * @name 打开详情
     */
    onOpenDetails(text){
      let { id } = text
      this.httpGetCommodityDetails(id)
    },
    /**
     * @name 获取商品详情
     */
    httpGetCommodityDetails(id){

      this.$request.get('?module=pc_api&action=product&app=set_product&shop_id=2',{ params:{ id } }).then(res => {
        let { code, data, message } = res
        if(code === 200){

          this.visible = true
          
          Object.assign(this,{
            CommodData: data
          })

          this.tableList(JSON.parse(data.checked_attr_list))

        } else {
          this.$message.warning(message)
        }        
      })
    },
    tableList(tableList){

      var column = []

      tableList[0].attr_list.filter(item=>{
        var name = item.attr_group_name

        column.push(
          {
            title: name,
            dataIndex: name,
            key: name,
          }
        )
      })

      column.push(...columnsc)

      this.columnsc = column
      

      var tableData = []
      

      tableList.filter(item=>{
        var arr = JSON.parse(JSON.stringify(item))

        delete arr['attr_list']

        item.attr_list.filter(items=>{
          arr[items.attr_group_name] = items.attr_name
        })
        
        tableData.push(arr)
      })

      this.tableData = JSON.parse(JSON.stringify(tableData))
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;

      function callback(list){
        
        let { class_list, brand_list, class_id} = list

        if(class_id){
          targetOption.isLeaf = true
          targetOption.loading = false
        }

        targetOption.loading = false

        if(class_list.length){

          let result = Array.from(class_list[0],item => {
            item.isLeaf = false
            return item
          })

          targetOption.children = [
            ...result
          ]
        }

        this.cache[targetOption.cid] = brand_list

        Object.assign(this,{
          options: [...this.options],
          brandlist: brand_list
        })

      }

      this.loadClass({ cid: targetOption.cid, },callback)

    },
    /**
     * @name 分类加载
     * */ 
    loadClass(data = { cid:1, brand_str:'' },callback){

      this.$request.get("?module=pc_api&action=product&app=choice_class",{ params: data }).then(res => {
        let { code, message, list } = res;
        if (code === 200) {

          callback.call(this,list)

        } else {
          this.$message.error(message);
        }
      });
    },
    handleSubmit(){

      let { product_class, proName, brand_id } = this

      let data = {}

      if(proName)  {data['proName']  = proName}
      if(brand_id) {data['brand_id'] = brand_id}
      
      for(let i in product_class){
        if(i == 0){
          data['product_class_id'] = product_class[i]
          continue
        }
        data['product_class_id' + i] = product_class[i]
      }
      
      this.httpQuery(data)
    },
    /**
     * @name 重置
     */
    onReset(){
      Object.assign(this,{
        product_class:[],
        proName:'',
        brand_id:undefined
      })
    },
    httpQuery(data){
	  this.current = 1
	  this.$set(this.pagination,'current',1)
      this.loading = true
      this.$request.get('?module=pc_api&action=product&app=goods_query',{ params: data }).then(res => {
        let { code, list, message , total } = res
        if(code == 200){
			if(list && list.length>0){
				let selectedRow = []
				let selectedRowKeys = []
				this.selected_list.filter(items=>{
					list.filter((item,index)=>{
						if(items.id == item.id){
							selectedRow.push(item)
							selectedRowKeys.push(index)
						}
					})	  
				})
				this.selectedRow = selectedRow
				this.selectedRowKeys = selectedRowKeys
			}
          
          Object.assign(this,{
            data: list,
            total: total,
            pagination: { total }
          })

          setTimeout(() => {
            this.loading = false
          },600)
        }
      })
    },
    onSelectChange(selectedRowKeys,selectedRow) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRow     = selectedRow
	  
	  // 把当前页选中的数据保存到对象中
	  
	  this.data.filter(items=>{
		  let i = this.selected_list.findIndex(item=>{
			  return items.id == item.id
		  })
		  
		  if(i>=0){
			  this.selected_list.splice(i,1)
		  }
	  })
	  
	  this.selected_list.push(...selectedRow)
    },
    initPage(){
      this.loading = true
      this.$request.post('?module=pc_api&action=product&app=add_goods_page').then(res => {
        let { code, message, list, total, freight_list } = res
        this.data.push(list)
        list = Array.from(list, item => {
          item.key = this.nums

          this.nums++
          
          return item
        })
		
		
        if(code === 200){
			freight_list.filter(item=>{
				if(item.status){
					this.freight_id = item.id
				}
			})
          Object.assign(this,{
			freight_list: freight_list,
            data: list,
            total: total,
            pagination: { total }
          })
		  
          setTimeout(() => {
            this.loading = false
          },0)
        } else {
          this.$message.error(message)
        }
      })
    },
    onDelp(index){
		let id = this.selected_list[index].id
		
		let selected_list = JSON.parse(JSON.stringify(this.selected_list))
		selected_list.splice(index,1)
		this.selected_list = []
		
		setTimeout(()=>{
			this.selected_list = selected_list
		},10)
		
		let is = this.selectedRow.findIndex(items=>{
			return items.id == id
		})
		
		if(is>=0){
			this.selectedRow.splice(is,1)
			this.selectedRowKeys.splice(is,1)
		}
		
    },
    /**
     * @name 商品分类
     */
    getCommodityClass(data = { class_str: 0, brand_str:'' }){

      this.$request.get("?module=pc_api&action=product&app=get_class",{ params: data }).then(res => {

        let { code, message, list } = res;
        if (code === 200) {

          let result = Array.from(list.class_list[0],item => {
            item.isLeaf = false
            return item
          })

          Object.assign(this,{
            // brandlist: list.brand_list,
            optionstype: result
          })

        } else {
          this.$message.error(message)
        }
      })


    },
    /**
     * @name 商品分类标签
     */
    getCommodityClassType(data = { class_str: 0}){

      this.$request.get("?module=pc_api&action=product&app=get_label",{ params: data }).then(res => {

        let { code, message, list } = res;
        if (code === 200) {
			
			let result = []
			if(list.class_list && list.class_list.length>0){
				result = Array.from(list.class_list[0],item => {
				  item.isLeaf = false
				  return item
				})
			}

          Object.assign(this,{
            // brandlist: list.brand_list,
            options: result
          })

        } else {
          this.$message.error(message);
        }
      });
    },
    onChange(value) {
      console.log(value);
    },
    /**
    * @name 返回
    * */ 
    onGoBack(){
      this.$router.go(-1)
    },
    /**
     * @name 提交
     */
    onFromBtn(){
      let { selected_list, spppid, freight_id } = this
      let arr,arrstr;

      if(!selected_list.length) {
        this.$message.warning('请选择需要添加的商品！')
        return
      }

      arr = Array.from(selected_list,item => {
        return item.id
      })

      arrstr = arr.join(',')
	  
      this.httpAddGoods({ pro_id: arrstr, spppid, freight_id })
    },
    httpAddGoods(params){
      this.$request.get('?module=pc_api&action=product&app=add_goods',{ params }).then(res => {
        let { code, message } = res

        if(code === 200){
          this.$message.success('自选商品添加成功')

          setTimeout(() => {
            this.onGoBack()
          },600)

        } else {
          this.$message.warning(message)
        }

      })
    }
  }
}
</script>

<style lang="less" scoped>
	/deep/.ant-card-body{
		padding-top: 0;
		padding-bottom: 0;
	}
	/deep/.optionalquery .ant-btn{
		padding: 0;
		width: 56px;
	}
	/deep/.optionalquery .ant-btn-primary{
		color: #fff;
		background-color: #323544;
		outline: 0;
		border: 0;
	}
	
.adcx {
  width: 440px;
}

.adcx img {
  width: 100%;
}
.client_manage {
	height: 100%;
	overflow-y: auto;
  
  .foot {
    height: 68px;
    width: 100%;
    border-top: 1px solid #e9ecef;
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 60px;
    background: #ffffff;
    z-index: 999;

    .btns {
      margin-right: 10px;
    }
	
	/deep/.ant-btn{
		width: 100px;
		padding: 0;
	}
  }

  .reminder {
    color: #969DA8;
    font-size: 14px;
    font-weight: 400;
  }

  .box-footer {
    display: flex;
    justify-content: space-between;
  }

  .optionalform {
    margin-top: 40px;

  }
}

.productimg {
  position: relative;
  margin-right: 10px;
}

.productimg-title {
  position: absolute;
  top: 35px;
  left: 0;
  width: 32px;
  height: 16px;
  background: #2890ff;
  line-height: 13px;
  font-size:12px;
  font-weight:400;
  color:rgba(255,255,255,1);
  text-align: center;
}

.box {
  height: 640px;
  overflow-y: overlay;
}

.ant-spin-nested-loading{
	// min-height: 450px;
}
</style>